import { BehaviorSubject, filter, Observable, timer } from 'rxjs';

import { getUpdateSessions, UpdateSessionEffects } from './update-session.state';

import { environment } from '../../../environments/environment';
import { rootStore } from '../extension-store/extension.store';
import { StateStatus } from '../extension-store/interfaces/extension-store.interfaces';
import UtilsSerice from '../utils/utils.service';

const extensionIsReady$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
const extensionIsOnline$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
const sessionUpdateTrigger$: Observable<number> = timer(
  0,
  environment.defaultTimings.userSessionCheckinRateInSeconds * 1000
).pipe(filter(() => extensionIsReady$.getValue() && extensionIsOnline$.getValue()));

const UpdateSessionService = {
  init: async (): Promise<void> => {
    UtilsSerice.debugLog('UpdateSessionService.init');

    rootStore.subscribe(() => {
      const state = rootStore.getState();
      if (state.checkInState.status === StateStatus.SUCCESS && state.checkInState.isCustomerValid) {
        extensionIsReady$.next(state.checkInState.isCustomerValid);
      }

      if (state.networkStatus.status === StateStatus.SUCCESS && state.networkStatus.networkStatus.isOnline) {
        extensionIsOnline$.next(state.networkStatus.networkStatus.isOnline);
      }
    });

    sessionUpdateTrigger$.subscribe(async () => {
      UtilsSerice.debugLog('UpdateSessionService: Triggering Session Update');
      const state = rootStore.getState();
      if (
        state.updateSessionState.status === StateStatus.IDLE ||
        state.updateSessionState.status === StateStatus.SUCCESS
      ) {
        const sessions = getUpdateSessions(state);
        UtilsSerice.debugLog('USER SESSIONS PINGS FOUND ', sessions);
        if (sessions.length > 0) {
          UtilsSerice.debugLog('UpdateSessionService: Sending Session Pings');
          await rootStore.dispatch(UpdateSessionEffects.sendSessionPings(sessions));
        }
      }
    });
  },
};

export default UpdateSessionService;
